import "../webflow/css/normalize.css";
import "../webflow/css/webflow.css";
import "../webflow/css/dialectical-living.webflow.css";
import "../css/global.css";

import Accordions from "./modules/Accordions";

const accordions = new Accordions();
